import React from "react";
import { useTranslation } from 'react-i18next';
import QuarriesAntalyaElmali1 from "../Components/quarries/QuarriesAntalyaElmali1";
import TopBar from "../Components/common/TopBar";
import Spacer from "../Components/common/Spacer";
import SEO from "../Components/common/SEO";

function AntalyaElmali1Page() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const seo = {
    title: currentLang === 'tr' ? 'Antalya Elmalı 1 Ocağı Mermerleri - MOCA Mermer' : 'Antalya Elmali 1 Quarry Marbles - MOCA Marble',
    description: currentLang === 'tr' ? 'Antalya Elmalı 1 mermer ocağından çıkarılan Cosmos Beige, Cloudy Beige, Elmalı Baiyulan ve Crema Montana mermer çeşitleri.' : 'Cosmos Beige, Cloudy Beige, Elmali Baiyulan and Crema Montana marble varieties from Antalya Elmali 1 quarry.',
    keywords: currentLang === 'tr' ? 'antalya elmalı 1 ocak, cosmos beige, cloudy beige, elmalı baiyulan, crema montana, mermer çeşitleri' : 'antalya elmali 1 quarry, cosmos beige, cloudy beige, elmali baiyulan, crema montana, marble varieties'
  };

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/antalyaelmali1"
      />
      <TopBar />
      <Spacer />
      <QuarriesAntalyaElmali1 />
    </>
  );
}

export default AntalyaElmali1Page;
